import React, { Component } from 'react';
// Externals
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from '@material-ui/core/Typography';
import TablePagination from '@material-ui/core/TablePagination'
import Button from '@material-ui/core/Button'
import Popover from '@material-ui/core/Popover';
import { Box, Card, CardContent, Dialog, DialogContent, Grid, TableBody, TableHead } from '@material-ui/core';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Screenshot from '../../../../../helpers/Screenshot';
import Tooltip from '@material-ui/core/Tooltip';
// Shared components
import { AtTimelineEvent } from '../../../../../components/AtTimeline/AtTimelineEvent'
// Component styles
import styles from '../styles';
import { api_host , api_auth} from '../../../../../common/globals/constants';
import icons from '../../../../../theme/icons.js';
import { lista_estados } from '../../../../../data/status_error_icons.js';
import { AtCircularProgress } from '../../../../../components/AtCircularProgress/index.jsx';
import { withTranslation } from 'react-i18next';

const moment = require('moment');
class EventsTable extends Component {
    _currentObjectiveId = null;
    
    constructor(props) {
        super(props);
        this.translation = props.t;
        this.state = {
            currentObjectiveId : this.props.match.params.objetivo_id,
            nodes: props.location.state.fromObjective.Nodos,
            service: props.location.state.fromObjective.grupo_servicio_unificado,
            loadObjectiveData : false,
            actualUptime: 0,
            externalData: null,
            dataError: false,
            isLoading: true,
            time: props.params.period,
            totalCell: 2,
            StatePeriod: props.params.StatePeriod, 
            pages: 1,
            page: 0, 
            isOpen: false,
            target: null,
            currentNode: null,
            currentDate: null,
            monitores: props.location.state.fromObjective.Monitores,
            listCdn: [],
            pasos_criticos: props.location.state.fromObjective.paso_critico
        }
    }
    static getDerivedStateFromProps(nextProps, prevState){
        if (nextProps.match.params.objetivo_id !== prevState.prevObjectiveId) {
            return {
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                isLoading: true,
                dataError: false,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.period !== prevState.time) {
            return {
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.period === prevState.time && nextProps.params.statePeriod !== prevState.statePeriod) {
            return {
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: prevState.time,
                dataError: false,
                isLoading: true,
                statePeriod: nextProps.params.statePeriod,
            }
        }
        return null;
    }
    componentDidMount() {
        this.getDataFromAPI();
    }  

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {
            this.getDataFromAPI();
        }
    }
    getDataFromAPI = (objectiveId) => {
        const { time, statePeriod, currentObjectiveId } = this.state
        let token = sessionStorage.getItem('key')
        let id_user = sessionStorage.getItem('user')
        let finalTime = (moment().format('YYYY-MM-DD HH:mm'))
        let beginTime = (moment().subtract(1, "hours").format('YYYY-MM-DD HH:mm'))
        if (this.state.time === 'd') {
            beginTime = (moment().subtract(1, "days").format('YYYY-MM-DD HH:mm'))
        } else if (this.state.time === 'w') {
            beginTime = (moment().subtract(1, "weeks").format('YYYY-MM-DD HH:mm'))
        } else if (this.state.time === '3h') {
            beginTime = (moment().subtract(3, "hours").format('YYYY-MM-DD HH:mm'))
        } else if (this.state.time === '3d') {
            beginTime = (moment().subtract(3, "days").format('YYYY-MM-DD HH:mm'))
        }
        
        let fecha_inicio = beginTime
        let fecha_termino = finalTime

        if (time === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10) + " 00:00"
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10) + " 00:00"           
            fetch(api_host+`/reporte/online/eventos/Reporte3EventsExpanded/?user=${id_user}&key=${api_auth}&objetive=${currentObjectiveId}&datebegin=${fecha_inicio}&finaldate=${fecha_termino}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}`)
                .then(response => response.json())
                .then(myJson => {
                    try {
                        this.processData(myJson)
                        
                    } catch (error) {
                        this.setState({
                            dataError: true,
                            data: null,
                            isLoading: false
                        });
                    }
                });
        } else {
            fetch(api_host+`/reporte/online/eventos/Reporte3EventsExpanded/?user=${id_user}&key=${api_auth}&objetive=${currentObjectiveId}&datebegin=${fecha_inicio}&finaldate=${fecha_termino}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}`)
                .then( response => response.json())
                .then( myJson =>  {
                    try {
                        this.processData(myJson)
                        
                    } catch (error) {
                    this.setState({
                        dataError: true,
                        data: null,
                        isLoading: false
                    });
                }
            });
        }
    }

    getFetchs = (objective, begin, final, monitores, token) =>{
        return new Promise((resolve, reject) => {
            var cdnList = []
            var fetches = []            
            monitores.forEach((value, key)=>{
                var monitor_id=(value)
                var getListScreenshot = fetch(api_host+`/reporte/general/objetivos/${objective}/screenshots/list_images/?token=${token}&fecha_inicio=${begin}&fecha_termino=${final}&monitor=${monitor_id}`)
                        .then( response => response.json())
                fetches.push(                    
                    getListScreenshot.then( dataCdn =>  { 
                            cdnList[key] = dataCdn;
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(cdnList);
            })      
        });
    }

    processData = (externalData) => {
        const dataEvents  = externalData;
        var cell = -Infinity
        var pages = -Infinity
        Object(dataEvents).map(element=>{
            if(element.data_nodo.length > pages){
                pages = element.data_nodo.length
            }
            Object(element.data_nodo).map(element_nodo=>{
                if(element_nodo.length > pages){
                    cell = element_nodo.length
                }
            })
            
        })
     
        this.setState({
            externalData: dataEvents,
            totalCell: cell,
            pages: pages
        })
    }

    togglePopover = (event) => {
        const {monitores, currentObjectiveId, target} = this.state
        let token = sessionStorage.getItem('key')
        let beginTitle = String(event.currentTarget.id).substring(0,19)
        let endTitle = String(event.currentTarget.id).substring(19,38)
        let targetEvent = event.currentTarget
        let currentNode = event.currentTarget.value
        
        if (target !== event.currentTarget){
            var fetchListScreenshot = this.getFetchs(currentObjectiveId, beginTitle, endTitle, monitores, token)
            fetchListScreenshot.then( value =>{
                this.setState({ isOpen: !this.state.isOpen,
                                target: targetEvent,
                                currentDate: beginTitle,
                                currentNode: currentNode,
                                listCdn: value});
            })
        }
    };

    handleClose = () =>{
        this.setState({
            isOpen: false,
        })
    }

    setOpen = ( ele, tokenPicture, stepToken, dateBeginScreenshot, patternName) => {
        this.setState({
            modalOpen : true,
            modalClose : false,
            tokenPicture : tokenPicture,
            stepToken : stepToken,
            nameStep : ele,
            dateBeginScreenshot: dateBeginScreenshot,
            pattern: patternName
        })
    }

    createCell(data_nodo, total, id, target, currentDate, currentNode, monitor_id, isOpen){
        const t = this.translation;
        const {listCdn, nodes, pasos_criticos} = this.state
        var foundNodeName = "" 
        var critic_step = 0
        if (currentNode && currentNode !== null && currentNode !== undefined){
            foundNodeName = nodes.find(node => parseInt(node.id_nodo) === parseInt(currentNode)).nodo;
            let monitor = nodes.find(node => parseInt(node.id_nodo) === parseInt(currentNode)).monitor
            if (pasos_criticos && Object.keys(pasos_criticos).length > 0) {
                const ordenes = pasos_criticos[monitor.toString()];
                if (ordenes) {
                    critic_step = ordenes[0]
                } else {
                    critic_step = pasos_criticos[""][0]
                }
            }
        }
        var cells = []
        let codesOk = [0,9,14,17,30,200,204,301,304,307,602,1000]
        let codesOkString = ['0','9','14','17','30','200','204','301','304','307','602','1000']
        let codes = t('codes', {returnObjects: true })
        Object(data_nodo).map(element=>{
            let up = 0
            let down = 0
            let noMON = 0
            Object(element.pasos).map(({estado, patrones})=>{
                if (estado != null && estado.toString().includes(",")){
                    var split = estado.split(",")
                    let upPatterns = 0
                    let downPatterns = 0
                    Object(split).map(status=>{
                        if(codesOkString.includes(status)){
                            upPatterns = upPatterns + 1
                        }else{
                            downPatterns = downPatterns + 1
                        }  
                    })
                    if (downPatterns > 0) {
                        down = down + 1
                    } else {
                        up = up + 1
                    }
                } else if(estado == null){
                    let upPatterns = 0
                    let downPatterns = 0
                    let noMonPatterns = 0
                    Object(patrones).map(({estado})=>{
                        if(codesOk.includes(estado) || codesOkString.includes(estado)){
                            upPatterns = upPatterns + 1
                        }else if(estado === 'sin monitoreo'){
                            noMonPatterns = noMonPatterns + 1
                        }else{
                            downPatterns = downPatterns + 1
                        }
                    })
                    if (downPatterns > 0) {
                        down = down + 1
                    } else if (upPatterns > 0){
                        up = up + 1
                    } else if (noMonPatterns > 0){
                        noMON = noMON + 1
                    }
                }else {
                    if(codesOk.includes(parseInt(estado))){
                        up = up + 1
                    }else if(estado === 'sin monitoreo'){
                        noMON = noMON + 1
                    }else{
                        down = down + 1
                    }
                }
            })
            let status = 0
            if(noMON >= 1){
                status = 'sin monitoreo'
            }else if(down >= 1){
                status = 'downtime'
            }else{
                status = "uptime"
            }
            cells.push({"elementos": element, "estado": status})
        })
        let listFilteredScreenshot = []
        listCdn.map( monitor  => { 
            if (monitor.length > 0){
                monitor.map( registro => {
                    if (parseInt(registro.monitor_id) == monitor_id){
                        listFilteredScreenshot.push(registro)
                    }
                })
            }
        })
        let cont = 1
        return (<div style={{display: 'flex'}}>
                {cells.map( elements => {   
                    let listTokenDateFinal = []
                    let listTokenFinal = []
                    var disableButton = true
                    if (listFilteredScreenshot.length > 0) {
                        let eventBegin = new Date(elements.elementos.desde)
                        let eventEnd = new Date(elements.elementos.hasta)
                        listFilteredScreenshot.map( screen => {
                            let screenDate = new Date(screen.fecha_creacion.replace('T', ' '))
                            if ((eventBegin <= screenDate) && (screenDate < eventEnd)) {
                                listTokenFinal.push(screen.tokens)
                                    listTokenDateFinal.push(screen.fecha_creacion.replace('T', ' '))
                            }
                        })
                    }           
                    const colorEvent = elements.estado === "sin monitoreo" ? '#A9A9A9' :
                                 elements.estado === "downtime" ? '#C2272D' : '#41B900';

                    if(target && (elements.elementos.desde === currentDate) && (parseInt(currentNode) === id)){
                        var steps = []
                        elements.elementos.pasos.map((step, key)=>{
                            var patterns = []
                            var patternName = ''
                            var status = 0
                            if(typeof(step.patrones)!="undefined"){
                                step.patrones.map(patron=>{
                                    patternName = patron.patron
                                    let new_step = (
                                        <TableCell style={{borderBottom: 'none'}}>
                                            <Typography style={{height: "50px", textAlign: 'center'}}>
                                                <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{t('monitoring.tools-section.events.modal.event.details.table.cell.tooltip.status.no-monitoring')+": Periodo sin monitoreo\n"+t('text.text.pattern')+": "+patternName}</div>} placement="left">
                                                    <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>
                                    );
                                    if (patron.estado.toString() in lista_estados){
                                        if (patron.monitor_id){
                                            if (parseInt(patron.monitor_id) === parseInt(monitor_id)) {
                                                var titleStatus = t('text.status')+": "+codes[patron?.estado ?? '-1']['name']
                                                var titlePattern = t('text.text.pattern')+": "+patternName
                                                var titleMon = ''
                                                if (patron.monitor_id)
                                                    var titleMon = "Isp: "+foundNodeName
                                                var icon = lista_estados[patron.estado].icono
                                                new_step = (
                                                    <TableCell style={{borderBottom: 'none', textAlign: 'center'}}>
                                                        <Typography style={{height: "50px", textAlign: 'center'}}>
                                                            <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{titleStatus+'\n'+titlePattern+'\n'+titleMon}</div>} placement="left">
                                                                <i style={{...icons.sprite, ...icons[icon], zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                            </Tooltip>
                                                        </Typography>
                                                    </TableCell>
                                                );
                                            } else {
                                                new_step = null
                                            }
                                        } else {
                                            var titleStatus = t('text.status')+": "+codes[patron?.estado ?? '-1']['name']
                                            var titlePattern = t('text.pattern')+": "+patternName
                                            var icon = lista_estados[patron.estado].icono
                                            new_step = (
                                                <TableCell style={{borderBottom: 'none', textAlign: 'center'}}>
                                                    <Typography style={{height: "50px", textAlign: 'center'}}>
                                                        <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{titleStatus+'\n'+titlePattern}</div>} placement="left">
                                                            <i style={{...icons.sprite, ...icons[icon], zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                        </Tooltip>
                                                    </Typography>
                                                </TableCell>
                                            );
                                        }
                                    } else if (step.estado?.toString() === 'sin monitoreo') {
                                        new_step = (
                                            <TableCell style={{borderBottom: 'none'}}>
                                                <Typography style={{height: "50px", textAlign: 'center'}}>
                                                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{t('monitoring.tools-section.events.modal.event.details.table.cell.tooltip.status.no-monitoring')+" "+t('text.text.pattern')+": "+patternName}</div>} placement="left">
                                                        <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>                    
                                                    </Tooltip>
                                                </Typography>
                                            </TableCell>
                                        );
                                    } else {
                                        new_step = (
                                            <TableCell style={{textAlign: 'center'}}>
                                                <Typography style={{height: "50px", textAlign: 'center'}}>
                                                    <Tooltip title="Error" placement="left">
                                                        <i style={{...icons.sprite, ...icons.spriteSIN_NOMBRE, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                    </Tooltip>
                                                </Typography>
                                            </TableCell>
                                        );
                                    }
                                    status = patron.estado
                                    patterns.push(new_step);
                                })
                            } else {
                                let new_step = (
                                    <TableCell style={{borderBottom: 'none'}}>
                                        <Typography style={{height: "50px", textAlign: 'center'}}>
                                            <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{t('monitoring.tools-section.events.modal.event.details.table.cell.tooltip.status.no-monitoring')}</div>} placement="left">
                                                <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>                    
                                            </Tooltip>
                                        </Typography>
                                    </TableCell>
                                );
                                if (step.estado.toString() in lista_estados){
                                    var titleStatus = "Estado: "+lista_estados[step.estado].nombre
                                    var icon = lista_estados[step.estado].icono
                                    new_step = (
                                        <TableCell style={{borderBottom: 'none', textAlign: 'center'}}>
                                            <Typography style={{height: "50px", textAlign: 'center'}}>
                                                <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{titleStatus+'\n'}</div>} placement="left">
                                                    <i style={{...icons.sprite, ...icons[icon], zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>
                                    );
                                } else if (step.estado.toString() === 'sin monitoreo') {
                                    new_step = (
                                        <TableCell style={{borderBottom: 'none'}}>
                                            <Typography style={{height: "50px", textAlign: 'center'}}>
                                                <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{t('monitoring.tools-section.events.modal.event.details.table.cell.tooltip.status.no-monitoring')}</div>} placement="left">
                                                    <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>                    
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>
                                    );
                                } else {
                                    new_step = (
                                        <TableCell style={{textAlign: 'center'}}>
                                            <Typography style={{height: "50px", textAlign: 'center'}}>
                                                <Tooltip title="Error" placement="left">
                                                    <i style={{...icons.sprite, ...icons.spriteSIN_NOMBRE, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>
                                    );
                                }
                                status = step.estado
                                patterns.push(new_step);
                            }
                            let token = 'NULL'
                            let date = null
                            listTokenFinal.map( (elements, index) => {   
                                if (elements[parseInt(step.id)] != 'NULL' && typeof(elements[parseInt(step.id)]) !== 'undefined'){
                                    token = elements[parseInt(step.id)]
                                    date = listTokenDateFinal[index]
                                }else{
                                    if (typeof(elements[parseInt(step.id)]) == 'undefined' && !codesOk.includes(status)){
                                        token = elements[parseInt(critic_step)];
                                        date = listTokenDateFinal[critic_step];
                                    }
                                }
                            })
                            var panorama = <Button onClick={(e)=>{this.setOpen(step.nombre_paso, token, parseInt(step.id), date, patternName)}}>
                                                <ImageOutlinedIcon />
                                            </Button>
                            if (token === 'NULL' || typeof(token) === 'undefined'){
                                panorama = <div />
                            } 

                            let new_step_final = (
                                <TableRow>
                                    <TableCell>{step.nombre_paso}</TableCell>
                                    <TableCell>
                                        {patterns.map(pattern=>(
                                            <div>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sm={6}
                                                    md={6}
                                                    xl={6}
                                                    style={{textAlign: 'center', justifyContent: 'center',aligItems: 'center',display: 'flex',margin:'auto'}}
                                                >
                                                    {pattern}
                                                </Grid>
                                            </div>
                                        ))}
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'center'}}>
                                    {panorama}
                                    </TableCell>
                                </TableRow>
                            );
                            steps.push(new_step_final)
                        });
                    }
                /*var duration = Math.trunc((new Date(elements.elementos.duracion).getTime() / (1000)) / 60)
      
                var msg = ''
                if (duration < 1) {
                    msg = msg+' hace pocos segundos'
                } else if (1 <= duration && duration < 60) {
                    msg = msg+' hace ' + duration + ' minuto(s)'
                } else if (60 <= duration && duration < 1440) {
                    var hour = Math.trunc(duration / 60)
                    var minute = duration - (60*hour)
                    msg = msg+' hace ' + hour + ' hora(s) con ' + minute + ' minuto(s)'
                } else if (1440 <= duration) {
                    msg = msg+' por más de 1 día'
                }*/
                var duration = elements.elementos.duracion.replace('day', 'día')
                return  <><Button id={elements["elementos"]["desde"]+elements["elementos"]["hasta"]} value={id} style={{padding:"0px"}} onClick={this.togglePopover} /*onClose={this.handleClose}*/>
                            <AtTimelineEvent
                                color={colorEvent}
                                title={elements.elementos.desde.substring(11,19)}
                                subtitle={elements.elementos.desde.substring(0,10)+'\n('+duration+')'}
                                titleProps={{}}
                                subtitleProps={{whiteSpace: 'pre-line', fontSize: '12px', color: '#686869'}}
                            />                            
                        </Button>
                            {steps !== undefined ? <Popover
                                anchorEl = {target}
                                open={this.state.isOpen}
                                onClose={this.togglePopover} 
                                target={elements["elementos"]["desde"]+'-'+id}
                                anchorOrigin={{
                                    vertical: 'center',
                                    horizontal: 'center'
                                }}
                                transformOrigin={{
                                    vertical: 'center',
                                    horizontal: 'center'
                                }}><Card>
                                    <CardContent style={{padding: 0}}>
                                    <Table size='small' className='table__cell--small-padding'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell colSpan={3} style={{ textAlign: 'center' }}>
                                                    {t("monitoring.tools-section.events.modal.event.details.title")}
                                                    <div style={{ textAlign: "center", marginTop: 5, display: "flex", justifyContent: "center" }}>
                                                        {currentDate.substring(11, 19)+' '}
                                                        {currentDate.substring(0, 10)}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                            <TableCell style={{ textAlign: "center" }}>
                                                {t("monitoring.tools-section.events.modal.event.details.table.step")}
                                            </TableCell>
                                            <TableCell style={{ textAlign: "center" }}>
                                                {t("monitoring.tools-section.events.modal.event.details.table.status")}
                                            </TableCell>
                                            <TableCell style={{ textAlign: "center" }}>
                                                {t("monitoring.tools-section.events.modal.event.details.table.screenshot")}
                                            </TableCell>
                                            </TableRow>
                                            {steps}
                                        </TableBody>                        
                                    </Table>
                                </CardContent>
                            </Card>
                            </Popover>
                            : null}
                        </>                                
                    })}
                </div>)
                                
    }

    createRow(arrayMap, pag, target, currentDate, currentNode, isOpen){
        const cellTotals = this.state.totalCell
        return (<div>
                    {arrayMap.map(({id, nombre_nodo, data_nodo, monitor_id})=>{     
                        if(data_nodo[pag]){           
                            return  <TableRow id={id} style={{height: 20 ,width:"800px", borderBottom: "1px solid #8a8a8a", }}>
                                        <TableCell style={{fontSize:"14px", borderBottom: "none", padding:"0px", textAlign:"center", minWidth: 200, maxWidth: 200}} component="th" scope="row">
                                            <Typography style={{fontSize: '18px'}} variant="h4">{nombre_nodo}</Typography>
                                        </TableCell>
                                        <TableCell style={{fontSize:"14px", borderBottom: "none", padding:"0px"}}>
                                            {this.createCell(data_nodo[pag], cellTotals, id, target, currentDate, currentNode, monitor_id, isOpen)}                                                
                                        </TableCell>
                                    </TableRow>
                        }
                    })}
                </div>)
    }

    handleChangePage = (e, page)=>{
        this.setState({
            page : page
        })
    }

    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true
        })
    }
    
    
    render() {
        const {pages, page, target, currentDate, currentNode, externalData, dataError, modalOpen, isOpen}=this.state
        const t = this.translation;
        if(pages > 1){
            var PaginationTableValidation = <TablePagination
                style={{}}
                rowsPerPageOptions={[5]}
                component="div"
                count={6 * pages}
                rowsPerPage={6}
                page={page}
                backIconButtonProps={{
                    'aria-label': 'previous page',
                }}
                nextIconButtonProps={{
                    'aria-label': 'next page',
                    }}
                onChangePage={this.handleChangePage}
                labelDisplayedRows={({ from, to, count }) => {
                        return `${from} - ${to} ${this.translation('text.of')} ${count}`
                    }
                }
            />
        }
        if (externalData !== null && !dataError )  {
            const row = this.createRow(externalData, page, target, currentDate, currentNode, isOpen)
            return(       
                <>
                    <Table>
                        {row}
                        {PaginationTableValidation}
                    </Table>
                    <Dialog
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={modalOpen}
                        onClose={this.setCloseModal}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 100,
                        }}               
                        >
                        <Fade in={modalOpen}>
                            <Screenshot data = {this.state}  onClose={this.setCloseModal}/>
                        </Fade>
                    </Dialog>
                </>        
            )
        }else{
            return ( 
                <AtCircularProgress />
            )
        }
    }
}

export default 
compose(
  withRouter,
  withStyles(styles),
  withTranslation()
)(EventsTable);